<template>
	<div class="dashboard-action-card">
		<img :src="getImageUrl()" :alt="props.title" class="dashboard-action-image" :title="props.alt_text" />
		<div v-html="props.title" class="dashboard-action-card-text"></div>
	</div>
</template>

<script setup>

const props = defineProps(['id', 'image_name', 'title', 'alt_text'])

function getImageUrl()
{
	return new URL(`/src/assets/images/icon/${props.image_name}`, import.meta.url)
}

</script>